export { default as IntercomWidget, shutdownIntercom } from './IntercomWidget';
